module.exports = __webpack_public_path__ + "static/25-8311f682dce7e41bf885d27e715c002d.mp4";